import { Image, ImageProps } from '@chakra-ui/react'
import React from 'react'

export const SvgIcon = (props: ImageProps) => <Image width="20px" {...props} />
